import React from "react";
import { CircularProgress, LinearProgress, Typography, Box, Stack } from "@mui/material";

interface LoadingSpinnerProps {
  message?: string;
  progress?: number;
}

export const LoadingSpinner = ({ message, progress }: LoadingSpinnerProps) => {
  return (
    <Stack
      direction="column"
      alignItems="center"
      justifyContent="center"
      spacing={3}
      sx={{ py: 6 }}
    >
      <Box sx={{ position: "relative" }}>
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            bgcolor: "primary.main",
            opacity: 0.2,
            filter: "blur(20px)",
            borderRadius: "50%",
            animation: "pulse 2s ease-in-out infinite",
            "@keyframes pulse": {
              "0%, 100%": { opacity: 0.2 },
              "50%": { opacity: 0.4 },
            },
          }}
        />
        <CircularProgress
          size={48}
          sx={{
            position: "relative",
            zIndex: 1,
            color: "primary.main",
          }}
        />
      </Box>

      {message && (
        <Typography
          variant="body2"
          color="text.secondary"
          align="center"
          sx={{
            maxWidth: 448,
            animation: "pulse 2s ease-in-out infinite",
            "@keyframes pulse": {
              "0%, 100%": { opacity: 0.6 },
              "50%": { opacity: 1 },
            },
          }}
        >
          {message}
        </Typography>
      )}

      {progress !== undefined && (
        <Box sx={{ width: "100%", maxWidth: 320 }}>
          <LinearProgress
            variant="determinate"
            value={progress}
            sx={{
              height: 8,
              borderRadius: 4,
              bgcolor: "grey.200",
              "& .MuiLinearProgress-bar": {
                background: "linear-gradient(90deg, #1976d2, #42a5f5)",
                borderRadius: 4,
                transition: "width 0.5s ease",
              },
            }}
          />
          <Typography
            variant="caption"
            color="text.secondary"
            align="center"
            sx={{ display: "block", mt: 1 }}
          >
            {progress}% complete
          </Typography>
        </Box>
      )}
    </Stack>
  );
};
